// The Users screen's sort (build plan §7.1 #10): by name, or by last sign-in,
// most recent first, with people who have never signed in last. Pure.

export type UserSort = "name" | "lastSignIn";

export const USER_SORTS: { value: UserSort; label: string }[] = [
  { value: "name", label: "Name" },
  { value: "lastSignIn", label: "Last sign-in (most recent first)" },
];

export function sortUsers<T extends { name: string; lastLoginUtc: string }>(users: readonly T[], by: UserSort): T[] {
  const byName = (a: T, b: T) => a.name.localeCompare(b.name);
  if (by === "name") return [...users].sort(byName);
  const at = (u: T) => {
    const t = Date.parse(u.lastLoginUtc);
    return Number.isNaN(t) ? -Infinity : t;
  };
  return [...users].sort((a, b) => at(b) - at(a) || byName(a, b));
}
